import {
  EXCEPTION_ALERT_DEFINITION_LIST,
  EXCEPTION_ALERT_DEFINITION_LIST_LOADING,
} from 'src/actions/constants';

export default function (state: any = { isListLoading: true }, action) {
  switch (action.type) {
    case EXCEPTION_ALERT_DEFINITION_LIST:
      return {
        ...state,
        isListLoading: false,
        exceptionAlertDefinitionListData: action.data,
      };
    case EXCEPTION_ALERT_DEFINITION_LIST_LOADING:
      return {
        ...state,
        isListLoading: true,
      };
    default:
      return state;
  }
}
